import {createContext} from "react";
import {ParentToChildMapping, ProfileGroup} from "../config/ProfileGroupMappings";
import {ForecastProfile} from "../live-monitoring/generated-src";


export const ProfileContext = createContext<ForecastProfile[]>([])
export const RegionsContext = createContext<string[]>([])
export const GroupsContext = createContext<Map<ProfileGroup, ParentToChildMapping[]>>(new Map())
